import type { ScanMode } from '@/lib/api';
import { SCAN_MODE_OPTIONS } from '@/lib/scanModes';

interface ScanModeChoiceProps {
  value: ScanMode;
  onChange: (mode: ScanMode) => void;
  disabled?: boolean;
}

/** The scan mode of a manual scan (END-177). Incremental is the default. */
export function ScanModeChoice({ value, onChange, disabled }: ScanModeChoiceProps) {
  return (
    <div role="radiogroup" aria-label="Scan mode" className="grid grid-cols-1 gap-[6px] sm:grid-cols-2">
      {SCAN_MODE_OPTIONS.map(({ mode, label, description }) => {
        const selected = value === mode;
        return (
          <button
            key={mode}
            type="button"
            role="radio"
            aria-checked={selected}
            disabled={disabled}
            onClick={() => onChange(mode)}
            className={`flex flex-col items-start gap-[3px] rounded-[8px] border p-[10px_12px] text-left font-[inherit] transition-all disabled:cursor-not-allowed disabled:opacity-50 ${
              selected
                ? 'border-[rgba(181,232,74,.35)] bg-[rgba(181,232,74,.06)]'
                : 'border-[rgba(255,255,255,.08)] bg-[#17171c] hover:border-[rgba(255,255,255,.16)]'
            }`}
          >
            <span className={`text-[12px] font-semibold ${selected ? 'text-[#b5e84a]' : 'text-foreground'}`}>{label}</span>
            <span className="font-mono text-[10px] leading-[1.45] text-muted-foreground">{description}</span>
          </button>
        );
      })}
    </div>
  );
}
